import objectKeysToCamelCase from '@grebban/utils/object/keysToCamelCase';
import { createSlice } from '@reduxjs/toolkit';
import resolveApplication from '@fogia/core-web/state/application/resolve';

export type IConfigState = Record<string, any>;

const initialState: IConfigState = {};

const slice = createSlice({
    name: 'config',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder.addCase(resolveApplication.fulfilled, (state, action) => {
            const { payload } = action;
            const config = objectKeysToCamelCase(payload?.data?.config ?? {}, {
                recursive: true,
                modifyInputObject: false,
            });
            const settings = objectKeysToCamelCase(payload?.data?.settings ?? {}, {
                recursive: true,
                modifyInputObject: false,
            });
            return { ...state, ...config, ...settings };
        });
    },
});

export {};
// export const {} = slice.actions;
export const { reducer } = slice;
